<template>
  <div>
    <div>
      <OrgTreeSelect
        :parentId="parentId"
        @getSelectValue="getSelectOrgValue"
        style="float:left;margin:0 0 0 10px;"
      ></OrgTreeSelect>
      <!--<el-input-->
        <!--placeholder="姓名"-->
        <!--v-model="filterName"-->
        <!--style="width:200px;float:left;margin:0 0 0 10px;"-->
      <!--&gt;</el-input>-->
      <el-input
        placeholder="工号/姓名/域账号"
        v-model="filterId"
        style="width:200px;float:left;margin:0 0 0 10px;"
      >
      </el-input>
      <el-button
        type="primary"
        icon="el-icon-search"
        @click="searchPerson"
        style="width:100px;float:left;margin:0 0 0 10px;"
      >搜索</el-button>
    </div>
    <el-table
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%;"
      @select="handleSelectionChange"
      v-loading="tableLoading"
    >
      <el-table-column
        type="selection"
        width="55"
      >
      </el-table-column>
      <el-table-column
        prop="OGU_GUID"
        label="工号"
        width="100"
      >
      </el-table-column>
      <el-table-column
        prop="OGU_NAME"
        label="姓名"
        width="150"
      >
      </el-table-column>
      <el-table-column
        prop="ORG_NAME"
        label="上级组织"
        width="150"
      >
      </el-table-column>
      <el-table-column
        prop="OGU_EMAIL"
        label="邮箱"
        width="200"
        show-overflow-tooltip
      >
      </el-table-column>
    </el-table>
    <div>
      <el-button
        type="primary"
        @click="confirmSelection()"
        style="float:left;"
      >确定</el-button>
      <el-button
        @click="clearSelection()"
        type="primary"
        style="float:left;margin:0 0 0 10px;"
      >清空全部选择</el-button>
      <el-pagination
        :background="pageBackground"
        layout="prev, pager, next"
        @current-change="handleCurrentPageChange"
        :total="totalRecords"
        :page-size="pageSize"
        :current-page="pageIndex"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
//引入多选控件
import OrgTreeSelect from "../plugins/OrgTreeSelect"
export default {
  data() {
    return {
      tableLoading:true,
      selectOrgPerson: [],
      selectOrgPersonName: '',
      selectOrgPersonIds: [],
      loading: true,
      tableData: [],
      pageBackground: true,
      pageSize: 8,
      pageIndex: 1,
      totalRecords: 0,
      filterName: "",
      filterId: "",
      filterOrg: [],
    };
  },
  directives: {
    selectDisableClose: {
      componentUpdated: function (el, bindings, vnode) {
        const dealStyle = function (tags) {
          tags.forEach((el, index) => {
            if (![el.classList].includes("select-tag-close-none")) {
              el.classList.add("select-tag-close-none");
            }
          });
        };
        setTimeout(() => {
          const tagTemp = el.querySelectorAll(".el-tag__close");
          dealStyle(tagTemp);
        });
      },
    },
  },
  props: {
    initValue: Array,
    multipleSelect: Boolean,
    selectDisabled: Boolean,
    parentId: String,
  },
  created() {
    this.initOrgPerson();
  },
  mounted() {
    //this.loadOrgPerson();
  },
  methods: {
    //多选变动后的回调函数，修改selectValue数组
    getSelectOrgValue(val) {
      this.filterOrg = val;
    },
    //页码改变
    handleCurrentPageChange(val) {
      this.pageIndex = val;
      this.loadOrgPerson();
    },
    handleSelectionChange(rows, row) {
      console.log(row)
      //console.log(rows)
      let selected = rows.length && rows.indexOf(row) !== -1
      if (!this.multipleSelect) {
        this.selectOrgPersonName = "";
        this.selectOrgPersonIds = "";
        this.selectOrgPerson = [];
        console.log(row)
        //其他选项都定为失效
        this.tableData.forEach((item) => {
          if (selected && item == row) {
            this.$refs.multipleTable.toggleRowSelection(item, true);
          } else {
            this.$refs.multipleTable.toggleRowSelection(item, false);
          }

        });
      }
      let orgPersonList = [];
      if (selected) {
        let addRow = true;
        for (let i = 0; i < this.selectOrgPerson.length; i++) {
          let orgPerson = this.selectOrgPerson[i];
          if (orgPerson.id == row.U_GUID) {
            addRow = false;
            break;
          }
        }
        if (addRow) {
          let orgPerson = [];
          orgPerson['id'] = row.U_GUID;
          orgPerson['name'] = row.OGU_NAME;
          this.selectOrgPerson.push(orgPerson);
        }
      } else {
        let selectOrgPersonNew = [];
        for (let i = 0; i < this.selectOrgPerson.length; i++) {
          let orgPerson = this.selectOrgPerson[i];
          if (orgPerson.id != row.U_GUID) {
            selectOrgPersonNew.push(orgPerson);
          }
        }
        this.selectOrgPerson = selectOrgPersonNew;
      }

      this.reBuildSelectOrgNameAndIds();
     // this.$emit("getSelectValue", this.selectOrgPersonIds);
    },
    confirmSelection() {
      this.showOrgPerson = false;
      this.$emit("getSelectValue", this.selectOrgPersonIds,this.selectOrgPersonName);
      this.$emit("confirmSelectPerson",true);
      this.$emit("showOrgPerson", false);

    },
    clearSelection() {
      this.selectOrgPersonName = '';
      this.selectOrgPersonIds = [];
      this.selectOrgPerson = [];
      this.$emit("getSelectValue", this.selectOrgPersonIds,this.selectOrgPersonName);
      this.$refs.multipleTable.clearSelection();
    },
    searchPerson() {
      this.pageIndex = 1;
      this.loadOrgPerson();
    },
    loadOrgPerson() {

      this.tableLoading = true;
      let wStr = "";
      let wForm = {}
      if (this.filterId) {
        wForm.oguGuidLike = this.filterId
      }
      if (this.filterName) {
        wForm.oguNameLike = this.filterName
      }
      let orgFilterGuid="";
      if(!this.filterOrg[0]){
        orgFilterGuid="";
      }else{
        orgFilterGuid=this.filterOrg[0];
      }
      this.$axios
        .get("/api/rbac/v0.1/orgAndUser/getOrgPersonListByPage", {
          params: {
            orgGuid: orgFilterGuid,
            page: this.pageIndex,
            pagesize: this.pageSize,
            wForm:encodeURIComponent(JSON.stringify(wForm))
          },
        })
        .then((res) => {
          var js = res.data;
          if (js.errcode == 0) {
            this.tableData = js.data.list;
            this.totalRecords = js.data.count;
            this.$nextTick(function () {
              this.tableData.forEach((row) => {
                if (this.selectOrgPersonIds.indexOf(row.U_GUID) >= 0) {
                  this.$refs.multipleTable.toggleRowSelection(row, true);
                }
              })
            })

            this.tableLoading = false;
          } else {
            this.tableLoading = false;
            this.$message({
              showClose: true,
              message: js.errmsg,
              type: "error",
            });
          }
        });
    },
    initOrgPerson() {
      console.log(this.initValue)
      this.selectOrgPersonName = '';
      this.selectOrgPersonIds = [];
      this.selectOrgPerson = [];
      if (!this.initValue || this.initValue.length == 0) {
        this.loadOrgPerson();
        return;
      }
     
      this.tableLoading = true;
      this.$axios
        .get("/api/rbac/v0.1/orgAndUser/getOrgPersonList", {
          params: {
            uGuids: this.initValue.join(","),
          },
        })
        .then((res) => {
          var js = res.data;
          if (js.errcode == 0) {
            let arrLabel = [];
            let arrValue = [];
            js.data.forEach((item) => {
              this.addOrgPerson(item);
            });
            this.loadOrgPerson();
            this.tableLoading = false;
          } else {
            this.tableLoading = false;
            this.$message({
              showClose: true,
              message: js.errmsg,
              type: "error",
            });
          }
        });
         
    },
    addOrgPerson(item) {
      //
      if (item) {
        let addRow = true;
        for (let i = 0; i < this.selectOrgPerson.length; i++) {
          let orgPerson = this.selectOrgPerson[i];
          if (orgPerson.id == item.UGUID) {
            addRow = false;
            break;
          }
        }
        if (addRow) {
          let orgPerson = [];
          orgPerson['id'] = item.UGUID;
          orgPerson['name'] = item.UNAME;
          this.selectOrgPerson.push(orgPerson);
          this.reBuildSelectOrgNameAndIds();
        }
      }
    },
    reBuildSelectOrgNameAndIds() {
      let arrLabel = [];
      let arrValue = [];
      if (this.selectOrgPerson && this.selectOrgPerson.length > 0) {
        this.selectOrgPerson.forEach(orgPerson => {
          arrLabel.push(orgPerson.name);
          arrValue.push(orgPerson.id);
        })

      }
      this.selectOrgPersonName = arrLabel.join(',');
      this.selectOrgPersonIds = arrValue;
    }

  },
  watch: {
    initValue() {
      this.initOrgPerson();
    },

  },
  //注册组件
  components: {
    OrgTreeSelect, //组织树
  },
};
</script>
<style>
.none {
  display: none;
}
</style>
